import React, { useState } from "react";
import type { CascaderProps } from "antd";
import { Cascader } from "antd";
import { DefaultOptionType } from "antd/es/cascader";
import newArrow from "../../assets/newArrow.svg";
import styles from "./style/index.module.scss";
import classNames from "classnames";

type SingleSelectProps = {
  onReset?: () => void;
  clear_text?: string;
};

const SingleSelectMobile = ({
  options,
  multiple,
  onChange,
  ...rest
}: CascaderProps<DefaultOptionType> & SingleSelectProps) => {
  const [open, setOpen] = useState(false);

  return (
    <div
      className={classNames({
        [styles.overrideCascader]: true,
        [styles.overrideSascaderActive]: open
      })}
    >
      <Cascader
        options={options}
        onChange={onChange}
        placeholder='Please select'
        allowClear={false}
        suffixIcon={<img src={newArrow} />}
        onDropdownVisibleChange={(visible) => setOpen(visible)}
        getPopupContainer={(node) => node.parentElement}
        dropdownRender={(menu) => <>{menu}</>}
        {...rest}
      />
    </div>
  );
};

export default SingleSelectMobile;
